import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function Home() {
  return (
    <div className="page-shell">
      <h3>首页</h3>
      <p>&nbsp;</p>
      <p className="page-lead">欢迎来到 WIND 产品展示平台。</p>
      <p>高效、智能、绿色，我们用科技改变生活，引领新时代潮流。我们专注于电子纸、OLED 与曲面显示方案，提供设备管理、固件升级与图像采集等能力。</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <div className="page-actions">
        <Link to="/oled" className="link-card" title="OLED">OLED方案</Link>
        <Link to="/flat" className="link-card" title="直面屏">直面屏方案</Link>
        <Link to="/curved" className="link-card" title="曲面屏">曲面屏方案</Link>
      </div>
    </div>
  );
}
export default Home;
